import { EVENTS } from '../../events';
import {View as PrechatFormView } from './view.template';
import {
    FieldText,
    FieldTextarea,
    FieldCheckbox,
    FieldRadio,
    FieldSelect
} from './fields';


/**
 * Chat alert notification plugin
 *
 * You can customize chat ringtone using chat settings like below
 *
 * `options: {
 *      ...
 *      prechatform: {
 *      }
 *  }`
 */
export class PreChatForm {

    constructor(chat){
        this.chat = chat;
    }

    init() {

		if (this.chat.options.is_admin) {
			this.chat.on(EVENTS.WSCHAT_ON_RENDER_USER_META, info => this.render_form_details(info));
		}

        if (!this.chat.options.prechatform ) {
        	return;
		}

        if (this.chat.options.prechatform.must_show_form === true) {
        	this.render_form();
        } else {
        	return;
        }

        this.chat.on(EVENTS.WSCHAT_ON_START_FAILURE, () => this.render_form());
        this.chat.on(EVENTS.WSCHAT_ON_RESIZE_WIDGET, () => this.resize_widget());

        this.chat.$el.find('.pre-chat-form-btn-submit').click((e) => this.submit_form(e));
    }

    resize_widget(height) {
        this.chat.$el.find('.pre-chat-panel').css({
            'min-height': height
        });
    }

    render_form() {
        const el = this.chat.$el.find('.pre-chat-panel .pre-chat-form');

        this.chat.$el.find('.pre-chat-panel').removeClass('d-none');
        this.chat.$el.find('.chat-panel').addClass('d-none');

        this.chat.$el.find('.pre-chat-form-title').text(this.chat.options.prechatform.label);

        this.chat.options.prechatform.fields.forEach(field => {
            this.inputs[field.type] && el.append(new this.inputs[field.type](field).render());
        });

        el.append(`<input type="hidden" name="action" value="${this.chat.options.prechatform.action}" /> `)
        el.append(`<input type="hidden" name="wschat_ajax_nonce" value="${wschat_ajax_obj.nonce}" /> `)
    }

    submit_form(e) {
        e.preventDefault();

        const frm = this.chat.$el.find('.pre-chat-form');

        frm.find('.is-invalid').removeClass('is-invalid');

        const data = frm.serialize();

        jQuery(e.target).prop('disabled', true);

        jQuery.post(this.chat.options.api.endpoint, data, (res) => {
         	this.chat.$el.find('.pre-chat-panel').remove();
         	this.chat.$el.find('.chat-panel').removeClass('d-none');
         	this.chat.connector.start_conversation();
        }).fail(function (f) {
        	jQuery(e.target).prop('disabled', false);

        	if (f.status !== 422) {
        		return;
        	}
        	const response = f.responseJSON;

        	for (let name in response.data) {
				frm.find(`[name="${name}"]`)
					.addClass('is-invalid')
					.parent().find('.invalid-feedback')
					.text(response.data[name].required);
        	}
        });
    }

    render_form_details(info) {
		const data = this.chat.conversation;

		if (data.meta && data.meta.pre_chat_form)
		{
			const pre_chat_data = Object.values(data.meta.pre_chat_form);

			const view = new PrechatFormView(pre_chat_data);
			info.append(view.render());

			info.find('.conversation-pre-chat-form ').removeClass('d-none');
		}
    }
}

PreChatForm.prototype.inputs = {
    text: FieldText,
    textarea: FieldTextarea,
    checkbox: FieldCheckbox,
    radio: FieldRadio,
    select: FieldSelect,
}

